import { CustomerSheet } from '@/components/customer-sheet/customer-sheet';
import { SidebarLayout } from '@/components/SidebarLayout/SidebarLayout';
import { VehicleSheet } from '@/components/vehicle-sheet/vehicle-sheet';
import { ServiceRequestSheet } from '@/components/service-request-sheet/service-request-sheet';
import { EventSheet } from '@/components/event-sheet/event-sheet';
import { SidePanelManagerProvider } from '@/contexts/side-panel-manager-context';
import { NewsSheet } from '@/components/new-news-sheet/news-sheet';
import { redirectIfUnauthenticated } from '@/utils/routes';
import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_protected')({
  component: PathlessLayoutComponent,
  beforeLoad: redirectIfUnauthenticated,
});

function PathlessLayoutComponent() {
  return (
    <>
      <SidePanelManagerProvider>
        <SidebarLayout>
          <Outlet />
          <CustomerSheet />
          <VehicleSheet />
          <ServiceRequestSheet />
          <EventSheet />
          <NewsSheet />
        </SidebarLayout>
      </SidePanelManagerProvider>
    </>
  );
}
